import React from 'react'

export const Loader = () => {
  return (
    <div className="vh-100 d-flex justify-content-center align-items-center">
            <h1 style={{color:'black'}}>Loading...</h1>
    </div>
  )
}
